import type { Theme } from '@emotion/react'
import { css } from '@emotion/react'
import { breakpoint, size } from '@twistopayments/design-system/styles'

export const highlighted = (theme: Theme) => css`
  color: ${theme.palette.secondary.mainContrast};
`

export const download = (theme: Theme) => css`
  padding: ${size[16]};
  display: flex;
  align-items: center;
  gap: ${size[16]};

  background-color: ${theme.palette.background.main};
  color: ${theme.palette.primary.mainContrast};
  border-radius: ${size[8]};
  box-shadow: 0px 9.6px 39.2px 0px #1d06281a;

  p {
    font-size: 22px;
  }

  & > img {
    width: 80px;
    height: 80px;
  }

  ${breakpoint.up('smMd')} {
    max-width: 300px;
    width: fit-content;
  }
`

export const extended = css`
  flex-direction: column;
  margin-top: ${size[24]};

  ${breakpoint.up('smMd')} {
    flex-direction: row;
    max-width: 446px;
    margin-top: ${size[48]};

    p {
      font-size: 24px;
    }

    & > img {
      width: 100px;
      height: 100px;
    }
  }
`

export const stores = css`
  margin-top: ${size[16]};
  display: flex;
  gap: ${size[12]};
`
